import { create } from "zustand";

// In-memory only: the category grid writes what it has loaded so the detail
// page can resolve `[id]` without refetching when the shopper clicks through.
export const useDesignIdeaImagesStore = create((set) => ({
  imagesByCategory: {},
  setImages: (category, items) =>
    set((state) => ({ imagesByCategory: { ...state.imagesByCategory, [category]: items } })),
}));
